export default __webpack_public_path__ + "static/media/chibi.73be95ce.jpg";